<template>
  <header class="header">
    <b-container fluid>
      <div class="main-nav">
        <div>
          <router-link to="/">
            <img src="@/assets/images/logoDark.png" alt class="logo" />
          </router-link>
        </div>
        <div class="d-md-block" v-bind:class="{ 'd-block' : navIsActive, 'd-none' : !navIsActive }">
          <nav class="main-nav-items" v-bind:class="{ 'animated fadeInDown': navIsActive}">
            <router-link
              class="main-nav-link"
              v-for="data in navItems"
              :key="data.title"
              router
              :to="data.link"
              :class="$route.path === data.link ? 'active-class' : 'inactive-class'"
            >{{data.title}}</router-link>
          </nav>
        </div>
        <div class="burger" v-on:click="showNavigation" v-bind:class="{ toggle : Istoggle}">
          <div class="burger-item line1"></div>
          <div class="burger-item line2"></div>
          <div class="burger-item line3"></div>
        </div>
      </div>
    </b-container>
  </header>
</template> 

<script>
export default {
  name: "appHeader",
  data() {
    return {
      navItems: [
        { title: "დეკორატიული კოსმეტიკა", link: "/cosmetics" },
        { title: "სახის მოვლა", link: "/skincare" },
        { title: "ტანის მოვლა", link: "/bodycare" },
        { title: "კონტაქტი", link: "/contact" }
      ],
      navIsActive: false,
      Istoggle: false
    };
  },
  methods: {
    showNavigation() {
      this.navIsActive = !this.navIsActive;
      this.Istoggle = !this.Istoggle;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/global";

.header {
  background: black;
  transition: 0.8s;
}
.logo {
  height: 3.5vh;
}
.main-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 90px;
  padding: 0 3vh;
  &-items {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    width: 80%;
    right: 0;
    z-index: 100;
    bottom: 0;
    top: 0;
    background: rgba(14, 14, 14, 1);
    opacity: 1;
    transition: 0.8s;
    position: fixed;
  }
  &-link {
    color: #fff;
    text-decoration: none;
    font-size: $font-sm;
    font-family: $fontDejaVuSans;
    padding-top: 15vh;
    letter-spacing: 0.1vh;
    &.active-class {
      color: $skyblueLight;
    }
    &.inactive-class {
      color: #fff;
    }
    &::after {
      content: "";
      display: block;
      width: 0;
      height: 1px;
      background: $skyblueLight;
      box-shadow: 2px 2px 5px 2px rgba(127, 209, 216, 0.6);
      transition: all 0.5s;
      top: 1vh;
      position: relative;
      opacity: 0;
    }
    &:hover::after {
      width: 100%;
      opacity: 1;
    }
  }
}
.burger {
  display: block;
  cursor: pointer;
  z-index: 101;
  position: fixed;
  right: 4vh;
  &-item {
    width: 30px;
    height: 3px;
    background: white;
    margin: 5px;
    transition: all 0.3s ease;
    &.line2 {
      width: 25px;
      margin-left: auto;
    }
    &.line3 {
      width: 20px;
      margin-left: auto;
    }
  }
  &:hover .line2,
  &:hover .line3 {
    width: 30px;
  }
}

.toggle {
  .line1 {
    width: 30px;
    transform: rotate(-45deg) translate(-5px, 6px);
  }
  .line2 {
    width: 30px;
    opacity: 0;
  }
  .line3 {
    width: 30px;
    transform: rotate(45deg) translate(-5px, -6px);
  }
}
.container-fluid {
  padding-left: 0;
  padding-right: 0;
}

/* =========== Responsive */

@media screen and (min-width: 768px) {
  .main-nav {
    &-items {
      flex-direction: row;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 0 3vh;
      position: static;
      transform: translateX(0);
      background: black;
      width: auto;
    }
    &-link {
      padding-left: 8vh;
      padding-top: 0;
      &.active-class {
        letter-spacing: 0.5vh;
      }
    }
  }
  .burger {
    display: none;
  }
  .container-fluid {
    padding-left: 15px;
    padding-right: 15px;
  }
}
</style>